import { EyeClosed, EyeOpen } from '@hungryroot/icons';
import { Icon } from './Icon';

export function PasswordMaskIcon({
  isPasswordInput,
  passwordMasked,
  onToggle,
}: {
  isPasswordInput: boolean;
  passwordMasked: boolean;
  onToggle: () => void;
}) {
  if (!isPasswordInput) {
    return null;
  }

  return (
    <Icon
      ariaLabel={`${passwordMasked ? 'Show' : 'Hide'} Password`}
      icon={passwordMasked ? <EyeOpen /> : <EyeClosed />}
      action={onToggle}
    />
  );
}
